import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { AddCompany, ListCompany } from "./pages";

const companyRoutes = [
  {
    path: "/companies",
    element: (
      <ProtectedRoute isNotEmployee>
        <ListCompany />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="company" />,
  },
  {
    path: "/companies/add",
    element: (
      <ProtectedRoute isNotEmployee>
        <AddCompany />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="companies.add_company" />,
  },
];

export default companyRoutes;
